export const PAGE_ROUTES = {
    ROOT: "/",
    Contact: "/Contact",
    Aboutus: "/About",
    ServicesPage: "/Services",
    Thankyou: "/ThankYou",
    Handshake: "https://app.joinhandshake.com/emp/employers/942531",
    Linkedin: "https://www.linkedin.com/company/oregonsoftwareconsultants/",
}
